import React, {useCallback, useEffect, useMemo} from "react";
import * as THREE from "three";
import {useGLTF_fixed_sharedLoad} from "../../../../../../Utils/ThreeJS/3JSHooks.js";
import {observer_mgl_r3} from "../../../../../../Utils/ThreeJS/General.js";
import {Vec3} from "../../../../../../Utils/ThreeJS/VectorStructs.js";

export const Bed = observer_mgl_r3((props: {extraProcessing_late?: (scene: THREE.Group)=>void})=>{
	const {extraProcessing_late} = props;
	//const {scene} = useGLTF_fixed("/3D/ZUp/Bed_5.0.glb");
	/*const {scene: scene_shared} = LoadGLTF_Fixed_Accessor("/3D/ZUp/Bed_5.0.glb");
	const scene = useMemo(()=>scene_shared?.clone(), [scene_shared]); // Clone the scene to avoid shared state issues*/
	const {scene} = useGLTF_fixed_sharedLoad("/3D/ZUp/Bed_5.0.glb");

	useEffect(()=>{
		if (scene == null) return;
		/*scene.traverse(node=>{
			if (node["isMesh"]) {
				const mesh = node as THREE.Mesh;
				//console.log(`Bed mesh(${mesh.name}):`, mesh);
				//extraProcessing_late?.(mesh);
				mesh.material = CreateLambertMatFromStandardMat(mesh.material as THREE.MeshStandardMaterial);
			}
		});*/

		scene.visible = false; // Hide bed initially
		scene.scale.set(.1, .1, .1); // Scale down the bed
		extraProcessing_late?.(scene);
	}, [extraProcessing_late, scene]);
	if (scene == null) return;

	return (
		<group position={new Vec3(0, 0, 0).To3JPos()} rotation={[0, 0, 0]}>
			<primitive object={scene!}/>
		</group>
	);
});